// extracted by mini-css-extract-plugin
export default {"BottomContainer":"TableFooter_BottomContainer__XpVer","InnerContainer":"TableFooter_InnerContainer__es9z+","DataProviderInfo":"TableFooter_DataProviderInfo__8Tb4b"};